import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import { Pencil } from 'lucide-react';
import { memo, useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import LangEnum from '../../lang/LangEnum';
import { useApplicationContext } from '../../modules/context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../modules/translation/TranslationContext';
import Banner from './Banner';

const useStyles = makeStyles()(() => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    position: 'absolute',
    zIndex: 1,
  },
  bannerControls: {
    position: 'absolute',
  },
}));

type BannerSectionProps = {
  bannerUrl?: string;
  placeHolder: string;
  readOnly?: boolean;
  objectFit?: 'cover' | 'contain';
  onEdit: () => void;
};

const BannerSection = ({
  objectFit = 'cover',
  bannerUrl,
  placeHolder,
  readOnly,
  onEdit,
}: BannerSectionProps) => {
  const { classes } = useStyles();
  const [withError, setWithError] = useState<boolean>(false);
  const { isStore } = useApplicationContext();
  const { translate } = useTranslation();

  useEffect(() => setWithError(false), [bannerUrl]);

  const handleShowImageError = () => setWithError(true);

  if (readOnly && withError) {
    return null;
  }

  if (readOnly) {
    return (
      <Banner
        objectFit={objectFit}
        src={bannerUrl}
        placeHolder={placeHolder}
        onError={handleShowImageError}
      />
    );
  }

  return (
    <div className={classes.container}>
      {onEdit && (
        <Button
          size="medium"
          variant="contained"
          color="primary"
          className={classes.button}
          startIcon={<Icon icon={Pencil} />}
          onClick={onEdit}
        >
          {isStore
            ? translate(LangEnum.STOREFRONT_ADD_PHOTO)
            : translate(LangEnum.SHOWROOM_ADD_PHOTO)}
        </Button>
      )}

      <Banner
        objectFit={objectFit}
        src={bannerUrl}
        placeHolder={placeHolder}
        onError={handleShowImageError}
      />
    </div>
  );
};

export default memo(BannerSection);
